import React, { useState } from "react";
import { Stack } from "@chakra-ui/react";
import { useCustomNotification } from "components/Toasts/OpenNotification";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import headerImage from "../../../../../assets/img/longarrow.jpg";
import GradientButton from "components/Buttons/GradientButton.js";
import ReusableInput from "components/Inputs/ReusableInput.js";

const PLATFORM_OPTIONS = [
  { label: "Android", value: "android" },
  { label: "iOS", value: "ios" },
];

const MAINTENANCE_OPTIONS = [
  { label: "Enabled", value: "true" },
  { label: "Disabled", value: "false" },
];

const AddAppVersionDrawer = ({ isOpen, onClose, onAddVersion }) => {
  const notify = useCustomNotification();

  const [formData, setFormData] = useState({
    platform: "android",
    latest_version: "",
    min_supported_version: "",
    store_url: "",
    maintenance_mode: false,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "latest_version" || name === "min_supported_version"
          ? Number(value)
          : name === "maintenance_mode"
          ? value === "true"
          : value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const response = await onAddVersion(formData);

      if (response?.success) {
        notify({
          message: "App Version Added",
          description: `Version ${formData.latest_version} for ${formData.platform} created successfully.`,
          type: "success",
        });

        setFormData({
          platform: "android",
          latest_version: "",
          min_supported_version: "",
          store_url: "",
          maintenance_mode: false,
        });

        onClose();
      } else {
        notify({
          message: "Failed to Add App Version",
          description: response?.error || "An error occurred while creating the app version.",
          type: "error",
        });
      }
    } catch (error) {
      notify({
        message: "Error",
        description: error.message || "Something went wrong while adding the app version.",
        type: "error",
      });
    }
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>Add App Version</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Platform"
            name="platform"
            value={formData.platform}
            onChange={handleInputChange}
            type="select"
            options={PLATFORM_OPTIONS}
            placeholder="Select platform"
          />

          <ReusableInput
            label="Latest Version"
            name="latest_version"
            value={formData.latest_version}
            onChange={handleInputChange}
            placeholder="Enter latest version"
            type="number"
          />

          <ReusableInput
            label="Minimum Supported Version"
            name="min_supported_version"
            value={formData.min_supported_version}
            onChange={handleInputChange}
            placeholder="Enter minimum supported version"
            type="number"
          />

          <ReusableInput
            label="Store URL"
            name="store_url"
            value={formData.store_url}
            onChange={handleInputChange}
            placeholder="Enter app store URL"
            type="text"
          />

          <ReusableInput
            label="Maintenance Mode"
            name="maintenance_mode"
            value={String(formData.maintenance_mode)}
            onChange={handleInputChange}
            type="select"
            options={MAINTENANCE_OPTIONS}
            placeholder="Select maintenance mode"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton
            onClick={onClose}
            fontSize="15px"
            width="100px"
            height="40px"
          >
            Cancel
          </GradientButton>

          <GradientButton
            onClick={handleSubmit}
            fontSize="15px"
            width="100px"
            height="40px"
            isDisabled={
              !formData.platform ||
              formData.latest_version === "" ||
              formData.min_supported_version === "" ||
              !formData.store_url
            }
          >
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AddAppVersionDrawer;